import Script from 'next/script';

import { AppConfig } from '@/utils/AppConfig';

export enum NpsTypes {
  QUESTION = 'q',
  VOC = 'v',
}

type NpsProps = {
  type: NpsTypes;
  slug: string;
};

const NpsWidgetScript = ({ type, slug }: NpsProps) => {
  const npsScriptUrl = `${AppConfig.environmentData.npsHost}/widget?q=${slug}&t=${type}&include-jquery`;
  return <Script src={npsScriptUrl} strategy={'lazyOnload'}></Script>;
};

export default NpsWidgetScript;
